var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loadMore"},[(!_vm.paginationComplete)?_c('a',{staticClass:"button",attrs:{"href":"#!"},on:{"click":function($event){$event.preventDefault();return _vm.loadMore.apply(null, arguments)}}},[_vm._v("Load More")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }